var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column"},[_c('span',{class:'cell-strategy ' + _vm.strategyType + ' analysis'},[_vm._v(" "+_vm._s(_vm.strategyType))])])}
var staticRenderFns = []

export { render, staticRenderFns }